import React, { useState } from 'react';
import Modal from '../../../components/ui/Modal';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const OwnerAgreementsActionsModal = ({ isOpen, onClose }) => {
  const [activeTab, setActiveTab] = useState('actions');
  const [formData, setFormData] = useState({
    ownerName: '',
    ownerId: '',
    propertyCount: '',
    agreementType: 'management',
    commission: '',
    duration: '',
    scope: '',
    aiDraft: false
  });

  const actions = [
    { id: 'ai-agreement', icon: 'FileCheck', label: 'اتفاقية ذكية', color: '#EF4444' },
    { id: 'authorization', icon: 'Key', label: 'تفويض إدارة', color: '#F59E0B' },
    { id: 'commission-calc', icon: 'Calculator', label: 'حساب العمولة', color: '#10B981' },
    { id: 'multi-property', icon: 'Building2', label: 'عقارات متعددة', color: '#3B82F6' },
    { id: 'renewal', icon: 'RefreshCw', label: 'تجديد تلقائي', color: '#8B5CF6' },
    { id: 'termination', icon: 'XCircle', label: 'إنهاء الاتفاقية', color: '#6B7280' }
  ];

  const templates = [
    { id: 'full-management', name: 'إدارة كاملة', scope: 'تسويق، صيانة، تحصيل' },
    { id: 'marketing-only', name: 'تسويق فقط', scope: 'إعلان وعرض العقار' },
    { id: 'exclusive', name: 'حصري', scope: 'تفويض حصري للوكالة' },
    { id: 'non-exclusive', name: 'غير حصري', scope: 'تفويض مشترك' }
  ];

  const handleAction = (actionId) => {
    console.log('Owner agreement action:', actionId);
  };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose} 
      title="اتفاقيات الملاك - الإجراءات والقوالب"
      icon=""
      iconColor=""
      footer={null}
    >
      <div className="space-y-6">
        <div className="flex gap-2 border-b border-border">
          <button
            onClick={() => setActiveTab('actions')}
            className={`px-4 py-2 font-medium transition-colors ${
              activeTab === 'actions' ?'text-primary border-b-2 border-primary' :'text-muted-foreground hover:text-foreground'
            }`}
          >
            الإجراءات
          </button>
          <button
            onClick={() => setActiveTab('templates')}
            className={`px-4 py-2 font-medium transition-colors ${
              activeTab === 'templates' ?'text-primary border-b-2 border-primary' :'text-muted-foreground hover:text-foreground'
            }`}
          >
            القوالب
          </button>
          <button
            onClick={() => setActiveTab('fields')}
            className={`px-4 py-2 font-medium transition-colors ${
              activeTab === 'fields' ?'text-primary border-b-2 border-primary' :'text-muted-foreground hover:text-foreground'
            }`}
          >
            الحقول
          </button>
        </div>

        {activeTab === 'actions' && (
          <div className="space-y-4">
            <div className="grid grid-cols-2 gap-3">
              {actions?.map((action) => (
                <button
                  key={action?.id}
                  onClick={() => handleAction(action?.id)}
                  className="p-4 rounded-lg border border-border hover:border-primary transition-all text-right group"
                >
                  <div className="flex items-center gap-3">
                    <div
                      className="w-10 h-10 rounded-lg flex items-center justify-center"
                      style={{ backgroundColor: `${action?.color}20` }}
                    >
                      <Icon name={action?.icon} size={20} color={action?.color} />
                    </div>
                    <span className="text-sm font-medium text-foreground group-hover:text-primary">
                      {action?.label}
                    </span>
                  </div>
                </button>
              ))}
            </div>

            <div className="bg-muted/50 rounded-lg p-4 space-y-3">
              <h3 className="text-sm font-semibold text-foreground flex items-center gap-2">
                <Icon name="Sparkles" size={16} />
                خيارات الذكاء الاصطناعي
              </h3>
              <div className="space-y-2">
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={formData?.aiDraft}
                    onChange={(e) => handleInputChange('aiDraft', e?.target?.checked)}
                    className="w-4 h-4 rounded border-border"
                  />
                  <span className="text-sm text-foreground">صياغة ذكية للاتفاقية</span>
                </label>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'templates' && (
          <div className="space-y-3">
            {templates?.map((template) => (
              <div
                key={template?.id}
                className="p-4 rounded-lg border border-border hover:border-primary transition-all cursor-pointer"
              >
                <div className="flex items-center justify-between">
                  <div>
                    <h4 className="text-sm font-semibold text-foreground">{template?.name}</h4>
                    <p className="text-xs text-muted-foreground mt-1">{template?.scope}</p>
                  </div>
                  <Button variant="outline" size="sm">
                    استخدام
                  </Button>
                </div>
              </div>
            ))}
          </div>
        )}

        {activeTab === 'fields' && (
          <div className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <Input
                label="اسم المالك"
                value={formData?.ownerName}
                onChange={(e) => handleInputChange('ownerName', e?.target?.value)}
                placeholder="الاسم الكامل"
              />
              <Input
                label="رقم الهوية"
                value={formData?.ownerId}
                onChange={(e) => handleInputChange('ownerId', e?.target?.value)}
                placeholder="رقم الهوية الوطنية"
              />
              <div>
                <label className="block text-sm font-medium text-foreground mb-2">نوع الاتفاقية</label>
                <select
                  value={formData?.agreementType}
                  onChange={(e) => handleInputChange('agreementType', e?.target?.value)}
                  className="w-full px-3 py-2 rounded-lg border border-border bg-background text-foreground"
                >
                  <option value="management">إدارة كاملة</option>
                  <option value="marketing">تسويق فقط</option>
                  <option value="exclusive">حصري</option>
                  <option value="non-exclusive">غير حصري</option>
                </select>
              </div>
              <Input
                label="عدد العقارات"
                type="number"
                value={formData?.propertyCount}
                onChange={(e) => handleInputChange('propertyCount', e?.target?.value)}
                placeholder="1"
              />
              <Input
                label="نسبة العمولة (%)"
                type="number"
                value={formData?.commission}
                onChange={(e) => handleInputChange('commission', e?.target?.value)}
                placeholder="5"
              />
              <Input
                label="مدة الاتفاقية (شهور)"
                type="number"
                value={formData?.duration}
                onChange={(e) => handleInputChange('duration', e?.target?.value)}
                placeholder="12"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-foreground mb-2">نطاق الخدمات</label>
              <textarea
                value={formData?.scope}
                onChange={(e) => handleInputChange('scope', e?.target?.value)}
                placeholder="تفاصيل الخدمات المشمولة في الاتفاقية..."
                rows={4}
                className="w-full px-3 py-2 rounded-lg border border-border bg-background text-foreground resize-none"
              />
            </div>
          </div>
        )}

        <div className="flex justify-end gap-3 pt-4 border-t border-border">
          <Button variant="outline" onClick={onClose}>
            إلغاء
          </Button>
          <Button variant="default">
            إنشاء الاتفاقية
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default OwnerAgreementsActionsModal;